export default "__VITE_ASSET__IrMywXk___"